webpackJsonp([22],{

/***/ 959:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(960);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(747)("09e58ef7", content, true);

/***/ }),

/***/ 960:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(746)(true);
// imports


// module
exports.push([module.i, ".login[data-v-5d964c89]{width:350px;max-width:100%}", "", {"version":3,"sources":["/home/runner/work/manager/manager/src/pages/Login.vue"],"names":[],"mappings":"AACA,wBACE,YAAa,AACb,cAAgB,CACjB","file":"Login.vue","sourcesContent":["\n.login[data-v-5d964c89] {\n  width: 350px;\n  max-width: 100%;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 997:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__(3);
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(7);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Login.vue




/* harmony default export */ var Login = ({
  data: function data() {
    return {
      form: {
        email: null,
        password: null,
        platformName: null
      }
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    platformName: 'application/platformName',
    loading: 'skiliko/session/isLoading',
    error: 'skiliko/session/loginError'
  })),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
    login: 'skiliko/session/login'
  }), {
    submit: function submit() {
      var _this = this;

      var data = extends_default()({}, this.form);
      data.platformName = data.platformName || this.platformName;
      this.login(data).then(function (_) {
        return _this.$router.replace({ path: _this.$route.query.redirect || '/' });
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d964c89","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Login.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"login"},[_c('v-card-title',[_vm._v("\n      "+_vm._s(_vm.$t('pages.login.title'))+"\n    ")]),_vm._v(" "),_c('v-card-text',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit()}}},[(!_vm.platformName)?_c('v-text-field',{attrs:{"name":"platformName","required":"","label":_vm.$t('pages.login.labels.platformName'),"id":"platformName"},model:{value:(_vm.form.platformName),callback:function ($$v) {_vm.$set(_vm.form, "platformName", $$v)},expression:"form.platformName"}}):_vm._e(),_vm._v(" "),_c('v-text-field',{attrs:{"name":"email","type":"email","required":"","label":_vm.$t('pages.login.labels.email'),"id":"email"},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}}),_vm._v(" "),_c('v-text-field',{attrs:{"name":"password","type":"password","required":"","label":_vm.$t('pages.login.labels.password'),"id":"password"},model:{value:(_vm.form.password),callback:function ($$v) {_vm.$set(_vm.form, "password", $$v)},expression:"form.password"}}),_vm._v(" "),_c('v-btn',{attrs:{"type":"submit","primary":"","light":"","block":"","ripple":"","loading":_vm.loading}},[_vm._v("\n          "+_vm._s(_vm.$t('pages.login.login'))+"\n        ")])],1),_vm._v(" "),_c('v-snackbar',{attrs:{"error":"","multi-line":"","timeout":2000},model:{value:(_vm.error),callback:function ($$v) {_vm.error=$$v},expression:"error"}},[_vm._v("\n        "+_vm._s(_vm.error)+"\n      ")])],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"block":"","flat":"","light":"","router":"","href":{ name: 'ForgotPassword' }}},[_vm._v(_vm._s(_vm.$t('pages.login.forgotPassword')))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var pages_Login = (esExports);
// CONCATENATED MODULE: ./src/pages/Login.vue
function injectStyle (ssrContext) {
  __webpack_require__(959)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d964c89"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Login,
  pages_Login,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_pages_Login = __webpack_exports__["default"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// static/js/22.c472588badb0546d6d41.js